import { Maybe } from '@/src/types';

type LayContext = () => Maybe<WebGLRenderingContext | WebGL2RenderingContext>;

// Context WebGL của các render window đang mở.
const cacContext = new Set<LayContext>();

/** Trả về hàm gỡ, gọi khi khung xem bị huỷ. */
export function ghiNhanContext(lay: LayContext): () => void {
  cacContext.add(lay);
  return () => {
    cacContext.delete(lay);
  };
}

/**
 * Mất WebGL thì vtk.js ném lỗi ở mọi lần vẽ sau đó, có khi trước cả sự kiện webglcontextlost. Đó là hệ quả: câu báo
 * "Khung xem ảnh ngừng hiển thị" đã đủ, không báo thêm từng lỗi.
 */
export function daMatWebGL(): boolean {
  return [...cacContext].some((lay) => {
    try {
      return lay()?.isContextLost() ?? false;
    } catch {
      return false;
    }
  });
}
